﻿import Event from "@model/Event"
import NoticeboardFile from "@model/NoticeboardFile"
import { Model } from "pinia-orm"
import { DateCast } from "pinia-orm/casts"
import { Attr, BelongsTo, Cast, HasMany, Num, OnDelete, Str, Uid } from "pinia-orm/decorators"

export default class NoticeboardEntry extends Model {
    static entity = 'noticeboard-entries'

    @Num( 0, { notNullable: true } ) declare id: number
    @Uid() declare eventId: string
    @BelongsTo( () => Event, 'eventId' ) declare event: Event
    @Cast( () => DateCast ) @Attr( '' ) declare when: string
    @Str( null ) declare desc: string
    @Str( null ) declare url: string
    @HasMany( () => NoticeboardFile, 'noticeboardEntryId' ) @OnDelete( 'cascade' ) declare files: NoticeboardFile[]

    get description (): string {
        if ( !URL.canParse( this.url ) )
            return this.desc !== null ? ( this.desc + ' ' + ( this.url ?? '' ) ).trim() : ( this.url ?? '' ).trim()

        return this.desc.trim() ?? ''
    }

    get link (): string | null {
        if ( this.url !== null && URL.canParse( this.url ) )
            return this.url

        return null
    }

    static piniaOptions = {
        persist: true
    }

}
